import {
  SHOW_MENA_BANNER,
  DISMISS_MENA_BANNER,
  MENA_COUNTRY_CODES
} from "./constants";
import { isMenaBannerDismissed, setMenaBannerDismissed } from "./sessionStore";
import { getCountryCode, getDefaultLanguage } from "../regionalStore/selectors";
import { getPlatform } from "../layout/selectors";
import { updatePreferences } from "../countrySelector/actions";
import { getContext } from "@src/client/context";

export const showMenaBanner = countryCode => ({
  type: SHOW_MENA_BANNER,
  payload: { countryCode }
});

export const dismissMenaBanner = () => ({
  type: DISMISS_MENA_BANNER
});

export const initMenaBanner = () => dispatch => {
  const geoCountry = getContext() && getContext().getGeoCountry();

  if (
    !MENA_COUNTRY_CODES.includes(geoCountry) ||
    isMenaBannerDismissed(geoCountry)
  ) {
    return;
  }

  dispatch(showMenaBanner(geoCountry));
};

export const stayHere = () => dispatch => {
  const geoCountry = getContext() && getContext().getGeoCountry();

  setMenaBannerDismissed(geoCountry);
  dispatch(dismissMenaBanner());
};

export const shopMena =
  () =>
  async (dispatch, getState, { api }) => {
    const state = getState();
    const context = getContext();
    const geoCountry = context && context.getGeoCountry();
    const initialCountryCode = getCountryCode(state);

    let countryData;

    try {
      const response = await api.fetchCountry(
        geoCountry,
        getDefaultLanguage(state),
        getPlatform(state)
      );
      countryData = response.data;
    } catch {
      return;
    }

    const country =
      countryData &&
      countryData.countries &&
      countryData.countries.find(
        ({ countryCode }) => countryCode === geoCountry
      );

    if (!country) {
      return;
    }

    const { currency, currencyId } =
      countryData.currencies.find(currency => currency.isPrimary) || {};

    return dispatch(
      updatePreferences({
        countryCode: geoCountry,
        currencyCode: currency,
        storeUrl: `//${country.url}`,
        initialCountryCode,
        affiliateId: context && context.getAffiliateId(),
        targetStore: {
          storeCode: countryData.storeCode,
          sizeSchema: countryData.sizeSchema,
          lang: countryData.lang,
          currencyId
        }
      })
    );
  };
